import { render, staticRenderFns } from "./input-select-date.vue?vue&type=template&id=4b620f8a"
import script from "./input-select-date.vue?vue&type=script&lang=js"
export * from "./input-select-date.vue?vue&type=script&lang=js"
import style0 from "./input-select-date.vue?vue&type=style&index=0&id=4b620f8a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports